export const ADMIN_PROFILE_INFORMATION_REQUEST = 'ADMIN_PROFILE_INFORMATION_REQUEST'
export const ADMIN_PROFILE_INFORMATION_REQUEST_SUCCESS = 'ADMIN_PROFILE_INFORMATION_REQUEST_SUCCESS'
export const ADMIN_PROFILE_INFORMATION_REQUEST_FAIL = 'ADMIN_PROFILE_INFORMATION_REQUEST_FAIL'

// export const ADMIN_FOOTER_INFORMATION_UPDATE_REQUEST = 'ADMIN_FOOTER_INFORMATION_REQUEST'
// export const ADMIN_FOOTER_PROFILE_INFORMATION_REQUEST_SUCCESS = 'ADMIN_FOOTER_PROFILE_INFORMATION_REQUEST_SUCCESS'
// export const ADMIN_FOOTER_PROFILE_INFORMATION_REQUEST_FAIL = 'ADMIN_FOOTER_PROFILE_INFORMATION_REQUEST_FAIL'

// export const ADMIN_INFORMATION_REQUEST = 'ADMIN_INFORMATION_REQUEST'
// export const ADMIN_INFORMATION_REQUEST_SUCCESS = 'ADMIN_INFORMATION_REQUEST_SUCCESS'
// export const ADMIN_INFORMATION_REQUEST_FAIL = 'ADMIN_INFORMATION_REQUEST_FAIL'

// export const ADMIN_UPDATE_PASSWORD_REQUEST = 'ADMIN_UPDATE_PASSWORD_REQUEST'
// export const ADMIN_UPDATE_PASSWORD_REQUEST_SUCCESS = 'ADMIN_UPDATE_PASSWORD_REQUEST_SUCCESS'
// export const ADMIN_UPDATE_PASSWORD_REQUEST_FAIL = 'ADMIN_UPDATE_PASSWORD_REQUEST_FAIL'

// export const ADMIN_UPDATE_IMAGE_REQUEST = 'ADMIN_UPDATE_IMAGE_REQUEST'
// export const ADMIN_UPDATE_IMAGE_SUCCESS = 'ADMIN_UPDATE_IMAGE_SUCCESS'
// export const ADMIN_UPDATE_IMAGE_FAIL = 'ADMIN_UPDATE_IMAGE_FAIL'